import React, { useEffect, useState } from "react";
import Bg from "../assets/images/bgn.png";
import NavbarComponent from "../components/home/NavbarComponent";
import Footer from "../components/home/Footer";
import Services from "../components/home/Services";
import { Link } from "react-router-dom";
import Service from "services/Services.service";

const Home = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      console.log("🔁 useEffect running...");
      const serviceInstance = new Service();
      try {
        console.log("🌐 Calling API...");
        const serviceResponse = await serviceInstance.getServices();
        const data = await serviceResponse.data; // If getRequest returns raw fetch Response
        console.log("✅ Services fetched:", data);
        setServices(data);
      } catch (err) {
        console.error("❌ Error fetching services:", err);
        setError("Failed to load services. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  return (
    <>
      <div
        className="pb-5 mb-5"
        style={{
          backgroundImage: `url(${Bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <NavbarComponent />
        <div className="tw-relative position-relative flex-grow">
          <div className="d-flex justify-content-center align-items-center mb-4 py-5 flex-column">
            <div className="py-3">
              <h5 className="text-white fw-semibold text-center my-4 display-5">
                REMA LICENCING PORTAL
              </h5>
              <p className="text-white text-center tw-leading-loose tw-text-justify">
                The REMA Licensing Portal serves as a centralized platform where
                applicants can submit their requests to REMA and conveniently
                track the status of their applications in real time.
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-center gap-3">
              <Link
                to="/login"
                className="btn btn-outline-light rounded-pill px-5 fw-bolder"
              >
                Login
              </Link>
              <Link
                to="/register"
                className="btn btn-outline-light rounded-pill px-5 fw-bolder"
              >
                Register
              </Link>
            </div>
          </div>

          <div
            className="tw-absolute position-absolute flex-grow-0 flex-shrink-0 tw-top-80 d-flex gap-5 flex-column tw-left-0 tw-right-0"
            style={{
              top: "85%",
              right: "0",
              left: "0",
              bottom: "0",
              margin: "auto",
            }}
          >
            {loading ? (
              <div className="text-center text-white fw-semibold py-5">
                Loading services...
              </div>
            ) : error ? (
              <div className="text-center text-danger fw-semibold py-5">
                {error}
              </div>
            ) : (
              <Services services={services} />
            )}

            <div className="mt-xxl-5">
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
